import Constants from "../utils/consts";
import Utils from "../utils/utils";

var http = require("follow-redirects").https;
var fs = require("fs");
var qs = require("querystring");

export default async function updateScontisticheCorso(
  uname,
  token,
  idCorso,
  scontistiche,
  files = null,
) {
  return new Promise(function(resolve, reject) {
    var options = {
      method: "POST",
      hostname: Constants.ipAddress,
      path: Constants.apisFolder + "updateScontisticheCorso.php",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Accept-Encoding": "identity",
        Cookie: "uid=e02675a1a7516909792f6850dffcd5fe",
      },
      maxRedirects: 20,
    };

    var req = http.request(options, function(res) {
      var chunks = [];

      res.on("data", function(chunk) {
        chunks.push(chunk);
      });

      res.on("end", function(chunk) {
        var body = Buffer.concat(chunks);
        try {
          const bodyStr = body.toString();
          console.log(
            "[updateScontisticheCorso] Risposta ricevuta:",
            bodyStr.length,
            "bytes, status:",
            res.statusCode,
          );
          if (!bodyStr || bodyStr.trim() === "") {
            console.warn(
              "[updateScontisticheCorso] Risposta vuota dal server (status: " +
                res.statusCode +
                ")",
            );
            // Se la risposta è vuota ma lo status è 200, assumiamo successo
            resolve(
              res.statusCode === 200
                ? { result: "ok", warning: "empty_response" }
                : { result: "error", error: "Risposta vuota dal server" },
            );
            return;
          }
          const resp = JSON.parse(bodyStr);
          resolve(resp);
        } catch (error) {
          console.error("Errore nel parsing della risposta:", error);
          console.error(
            "Contenuto ricevuto (" + body.length + " bytes):",
            body.toString().substring(0, 500),
          );
          // Se status 200 nonostante errore parsing, assumiamo successo
          if (res.statusCode === 200) {
            resolve({ result: "ok", warning: "parse_error" });
          } else {
            resolve({ result: "error" });
          }
        }
      });

      res.on("error", function(error) {
        console.error("Errore nella richiesta:", error);
        resolve({ result: "error" });
      });
    });

    var postData = qs.stringify({
      token: token,
      uname: uname,
      id_corso: idCorso,
      scontistiche: scontistiche,
      files: files,
    });

    req.write(postData);
    req.end();
  });
}
